/* eslint-disable no-undef */
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:
require("../src/javascripts/font-awesome");
require("../src/javascripts/event_detail_app_button");
require("../src/stylesheets/application.scss");
require("../lib/viewed_events_tracker");
require("../lib/web_push_notifications"); // ブラウザのデスクトップ通知（TGW-3137）。購読済みブラウザのトークン更新と手前表示
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
